import React from 'react';

import JoinTheTeam from './JoinTheTeam';
// import TeamWall from './TeamWall';

const WhoWeAre = (): JSX.Element => {
  return (
    <>
      {/* <TeamWall /> */}
      <JoinTheTeam />
    </>
  );
};

export default WhoWeAre;
